import insertIntoComposer from 'actions/team_assist/lib/insert_into_composer';
import isTeamAssistV2Enabled from 'actions/team_assist_v2/lib/is_team_assist_v2_enabled';

// `messageId` is the answer the draft came from.
export default class UseTeamAssistV2Reply {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, html, messageId }) {
    if (!isTeamAssistV2Enabled(this.context.stores.appFeatures.get())) {
      return;
    }
    if (!html || !customerId || !this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    this.context.analytics.track('Team Assist Suggested Response Used', {
      customerId,
      messageId,
      teamAssistVersion: 'v2',
    });
    insertIntoComposer(this.context, this.context.stores.customers.storesFor(customerId), html);
  }
}
